import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ColumnRow from "./columnRow";
// core imports
import SFCard, { SFCardBody } from "../../../components/card";
import { SFGridContainer, SFGridItem, SFStack } from "../../../components/grid";
import { SFInfoIconFilled } from "../../../components/icons";
import SFHaloIconWrapper from "../../../components/icons/halo";
import SFDivider from "../../../components/divider";
import getStyled from "../../../hooks/getStyled";
import SFTypography from "../../../components/typography";

const { styled } = getStyled();

const StyledDivider = styled(SFDivider)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
}));

const SFFieldMapping = ({ showWarning }) => {
  const reduxState = useSelector((state) => state.fileUpload);
  const { t } = useTranslation();

  const optionalColumns = reduxState.columnMappings?.filter((x) => !x.required) || [];

  return (
    <SFGridContainer spacing={2}>
      <SFGridItem xs={12}>
        <SFCard>
          <SFCardBody>
            <SFStack direction="row" alignItems="center" spacing={4}>
              <div>
                <SFHaloIconWrapper variant="grey" ignoreIcon>
                  <SFInfoIconFilled color="blue500" />
                </SFHaloIconWrapper>
              </div>
              <SFTypography variant="body1bold">
                {t("fileUploadWizard.fileMapping.mappingInfoLabel")}
              </SFTypography>
            </SFStack>
          </SFCardBody>
        </SFCard>
      </SFGridItem>
      <SFGridItem xs={12}>
        <SFTypography variant="body2bold" color="red300">
          {t(
            "fileUploadWizard.fileMapping.requiredColumnsLabel"
          ).toLocaleUpperCase()}
        </SFTypography>
        <StyledDivider />
      </SFGridItem>
      <SFGridItem xs={12}>
        {reduxState.columnMappings
          ?.filter((x) => x.required)
          .map((f, i) => (
            <ColumnRow
              key={f.dest}
              mapping={f}
              colIndex={i}
              showWarning={showWarning}
            />
          ))}
      </SFGridItem>
      {optionalColumns.length > 0 && (
        <>
          <SFGridItem xs={12}>
            <SFTypography variant="body2bold">
              {t(
                "fileUploadWizard.fileMapping.optionalColumnsLabel"
              ).toLocaleUpperCase()}
            </SFTypography>
            <StyledDivider />
          </SFGridItem>
          <SFGridItem xs={12}>
            {optionalColumns.map((f, i) => (
              <ColumnRow
                key={f.dest}
                mapping={f}
                colIndex={
                  reduxState.columnMappings.filter((x) => x.required).length + i
                }
              />
            ))}
          </SFGridItem>
        </>
      )}
    </SFGridContainer>
  );
};

SFFieldMapping.propTypes = {
  showWarning: PropTypes.bool,
};

export default SFFieldMapping;
